module.exports = __webpack_public_path__ + "static/media/upgrade-alt.c21dd9b6.svg";